import { AlertCircle } from 'lucide-react';
import { humanizeApiError } from '@/lib/error-messages';

/**
 * Shared inline error banner. Always renders a plain-English sentence — never
 * a raw code or stack trace. The raw error is still logged to the console via
 * `humanizeApiError` so developers can inspect it in dev-tools.
 */
export function ErrorBanner({ error }: { error: unknown }): JSX.Element {
  const { title, description } = humanizeApiError(error);
  return (
    <div className="flex items-start gap-3 rounded-md border border-destructive/40 bg-destructive/5 p-3 text-sm text-destructive">
      <AlertCircle className="mt-0.5 h-4 w-4 flex-none" />
      <div className="space-y-0.5">
        <div className="font-medium">{title}</div>
        <div className="whitespace-pre-line opacity-90">{description}</div>
      </div>
    </div>
  );
}
